import { setEnvironmentSpecificStyles } from '/src/styles/common/dynamicStyle';

export default async () => {
  const nuxtApp = useNuxtApp();
  const store = nuxtApp.$store;

  if (!store.getters.themeDetails.isApplied) {
    setEnvironmentSpecificStyles(store.getters.themeDetails);
    store.commit('user-login/setClientThemeDetails', { ...store.getters.themeDetails, isApplied: true });
  }
};
